import {
  TFilterSelected,
  TListingFetchReason,
  TREQUEST_DELETE_EMPLOYEE,
  TREQUEST_UPDATE_EMPLOYEE,
  TRESPONSE_DELETE_EMPLOYEE_REPLACEMENTS,
  TRESPONSE_EMPLOYEE_LIST,
} from '@monorepo/types';
import { TUserPaginationOption } from '@monorepo/ui';
import { Action } from '@ngrx/store';
import { TEmployeeManagementActionType } from './employee-management.models';

export class GetEmployeeListInfo implements Action {
  readonly type = TEmployeeManagementActionType.GetEmployeeList;
  constructor(public selectedFilters: TFilterSelected[] = [], public fetchReason: TListingFetchReason) {}
}

export class GetEmployeeListInfoSuccess implements Action {
  readonly type = TEmployeeManagementActionType.GetEmployeeListSuccess;
  constructor(public employeeListRes: TRESPONSE_EMPLOYEE_LIST, public fetchReason: TListingFetchReason) {}
}

export class GetEmployeeListInfoFailure implements Action {
  readonly type = TEmployeeManagementActionType.GetEmployeeListFailure;
}

export class SetEmployeeListPagination implements Action {
  readonly type = TEmployeeManagementActionType.SetEmployeeListPagination;
  constructor(public pagination: TUserPaginationOption) {}
}

export class UpdateEmployee implements Action {
  readonly type = TEmployeeManagementActionType.UpdateEmployee;
  constructor(public payload: TREQUEST_UPDATE_EMPLOYEE) {}
}

export class UpdateEmployeeSuccess implements Action {
  readonly type = TEmployeeManagementActionType.UpdateEmployeeSuccess;
}

export class UpdateEmployeeFailure implements Action {
  readonly type = TEmployeeManagementActionType.UpdateEmployeeFailure;
}

export class DeleteEmployee implements Action {
  readonly type = TEmployeeManagementActionType.DeleteEmployee;
  constructor(public payload: Omit<TREQUEST_DELETE_EMPLOYEE, 'factoryId'>) {}
}

export class DeleteEmployeeSuccess implements Action {
  readonly type = TEmployeeManagementActionType.DeleteEmployeeSuccess;
}

export class DeleteEmployeeFailure implements Action {
  readonly type = TEmployeeManagementActionType.DeleteEmployeeFailure;
}

export class DeleteEmployeeReplacements implements Action {
  readonly type = TEmployeeManagementActionType.DeleteEmployeeReplacements;
  constructor(
    public employeeId: TRESPONSE_EMPLOYEE_LIST['employeesWithAssignments'][number]['employee']['employeeId'],
  ) {}
}

export class DeleteEmployeeReplacementsSuccess implements Action {
  readonly type = TEmployeeManagementActionType.DeleteEmployeeReplacementsSuccess;
  constructor(public res: TRESPONSE_DELETE_EMPLOYEE_REPLACEMENTS) {}
}

export class DeleteEmployeeReplacementsFailure implements Action {
  readonly type = TEmployeeManagementActionType.DeleteEmployeeReplacementsFailure;
}

export class UpdateEmployeeManagementPageNo implements Action {
  readonly type = TEmployeeManagementActionType.UpdateEmployeeManagementPageNo;
  constructor(public page: number) {}
}

export class UpdateEmployeeManagementItemsPerPage implements Action {
  readonly type = TEmployeeManagementActionType.UpdateEmployeeManagementItemsPerPage;
  constructor(public itemsPerPage: number) {}
}

export type TEmployeeManagementActions =
  | SetEmployeeListPagination
  | GetEmployeeListInfo
  | GetEmployeeListInfoSuccess
  | GetEmployeeListInfoFailure
  | UpdateEmployee
  | UpdateEmployeeSuccess
  | UpdateEmployeeFailure
  | DeleteEmployee
  | DeleteEmployeeSuccess
  | DeleteEmployeeFailure
  | DeleteEmployeeReplacements
  | DeleteEmployeeReplacementsSuccess
  | DeleteEmployeeReplacementsFailure
  | UpdateEmployeeManagementPageNo
  | UpdateEmployeeManagementItemsPerPage;
